import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import DashboardSidebar from './DashboardSidebar';
import MyCleanStudioHeader from './MyCleanStudioHeader';
import MyCleanStudioFooter from './MyCleanStudioFooter';
import './DashboardLayout.css';

function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };


  return (
    <div className="dashboard-layout">
      {/* Common Header */}
      <MyCleanStudioHeader
        showMobileMenu
        onMobileMenuClick={toggleSidebar}
      />

      {/* Overlay */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar} />}

      {/* Sidebar and Main Content Container */}
      <div className="dashboard-body">
        <DashboardSidebar isOpen={sidebarOpen} onClose={closeSidebar} />
        <div className="dashboard-main">
          <main className="dashboard-content">
            <Outlet />
          </main>
        </div>
      </div>

      {/* Footer - Full width below sidebar */}
      <MyCleanStudioFooter />
    </div>
  );
}

export default DashboardLayout;

